import { IMenuCommand } from 'enchoice-fabric-react-lib';

export const exportToExcelCmd: IMenuCommand = {
  id: 'ExportToExcel',
  name: 'Export to Excel',
  icon: 'ExcelDocument'
};

export const exportToPdfCmd: IMenuCommand = {
  id: 'ExportToPdf',
  name: 'Export to Pdf',
  icon: 'Pdf'
};

export const editDocumentCmd: IMenuCommand = {
  id: 'EditDocument',
  name: 'Edit Document',
  icon: 'Edit'
};

export const AllMenuCommandsEnum = {
  XLSX: exportToExcelCmd,
  PDF: exportToPdfCmd,
  EDIT: editDocumentCmd
};

export const AllMenuCommands: IMenuCommand[] = [AllMenuCommandsEnum.XLSX, AllMenuCommandsEnum.PDF, AllMenuCommandsEnum.EDIT];
